/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';

import ErrorImage from '../ErrorImage';
import NoImage from '../NoImage';
import { list as imageList, loading as loadingImageSlice, error as errorImageSlice } from './../../pages/MyApplicationsPage/applicationImageSlice';
import { IMAGE_SLICE_NAME } from './../../pages/MyApplicationsPage/constants';
import { t } from '../../providers';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((_theme) => ({
    appImage: {
        width: 'inherit',
        height: 'inherit',
        objectFit: 'scale-down',
    },
    appImageGrid: {
        maxHeight: '170px',
        maxWidth: '330px',
        objectFit: 'unset',
        height: '90%',
    },
    imageLink: {
        height: '177px',
        width: '100%',
    },
}));

const ApplicationImage = ({ application, imageClass = 'appImage', selectedTab }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const loading = useSelector(loadingImageSlice);
    const error = useSelector(errorImageSlice);
    const applicationImage = useSelector(imageList);
    const { images } = applicationImage || '';
    const { loadingImages } = loading || false;
    const { errorImages } = error || false;
    const { graphicalRepresentation: image, multimediaUrl: mediaLink, modality } = application;

    const [imageError, setImageError] = useState(false);

    const getApplicationImage = (imageID, selectedTab) => {
        let params = {
            requestBody: {
                imageId: imageID,
            },
            selectedTab: selectedTab,
        };
        dispatch({ type: `${IMAGE_SLICE_NAME}/requestImage`, payload: { params } });
    };

    useEffect(() => {
        if (image != null && image.length < 51 && (!errorImages || (errorImages && errorImages[image] === undefined))) {
            getApplicationImage(image, selectedTab);
        }
    }, [image]);

    useEffect(() => {
        if (error && error !== null && errorImages[image]) {
            setImageError({ [image]: true });
        }
    }, [error]);

    const applicationImg =
        (images && images[image] && images[image].content) || (image != null && image.length > 51) ? (
            <img
                src={image.length < 51 ? 'data:image/jpeg;base64,'.concat(images[image].content) : 'data:image/jpeg;base64,'.concat(image)}
                className={classes[imageClass]}
                alt={`${t('graphical.representation.alt')} ${t(modality)}`}
                style={{ maxWidth: '330px' }}
            />
        ) : (
            <React.Fragment>
                <NoImage imageClass={imageClass} />
            </React.Fragment>
        );

    return (
        <React.Fragment>
            {(image != null && image.length > 51) || !loading || !loadingImages[image] ? (
                <React.Fragment>
                    {((errorImages && errorImages[image]) || (imageError && imageError[image])) && image != null && image.length < 51 ? (
                        <ErrorImage
                            imageClass={imageClass}
                            action={getApplicationImage}
                            imageId={image}
                            selectedTab={selectedTab}
                            application={application}
                        />
                    ) : mediaLink ? (
                        <a href={mediaLink} target={'_blank'} rel="noopener noreferrer" className={classes.imageLink}>
                            {applicationImg}
                        </a>
                    ) : (
                        applicationImg
                    )}
                </React.Fragment>
            ) : (
                <Box display="flex" alignItems="center" justifyContent="center">
                    <CircularProgress aria-hidden="true" />
                    <Typography variant="srOnly" role="alert">
                        {t('loading.text')}
                    </Typography>
                </Box>
            )}
        </React.Fragment>
    );
};

export default ApplicationImage;
